export function PageNav({ active, onChange }) {
    const tabs = [
        { id: "snapshot", label: "Executive Snapshot" },
        { id: "dimensions", label: "Dimension Insights" },
        { id: "archetype", label: "Archetype Profile" },
        { id: "coaching", label: "Coaching Guidance" },
        { id: "notes", label: "Coach Notes" },
    ];
    return (
        <div data-testid="report-nav" className="flex gap-1 p-1 bg-slate-100 rounded-xl overflow-x-auto">
            {tabs.map(t => (
                <button key={t.id} data-testid={`tab-${t.id}`}
                    onClick={() => onChange(t.id)}
                    className={`px-4 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-all ${active === t.id ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
                    style={{ fontFamily: "Manrope" }}>
                    {t.label}
                </button>
            ))}
        </div>
    );
}
